export const testimonials = [
  {
    id: "t1",
    nickname: "南城夜归人",
    role: "消费维权投稿人",
    quote:
      "本来只是抱着试试看的心态提交，没想到编辑会认真追问细节，还教我补充了关键的时间点，全程没有要求我提供真实姓名。",
    stars: 5,
  },
  {
    id: "t2",
    nickname: "匿名的第 37 号",
    role: "行业内部投稿人",
    quote:
      "从在线投稿到编辑回信不到两天，沟通方式很克制，只有需要核实的部分才联系我，这一点让人放心。",
    stars: 5,
  },
  {
    id: "t3",
    nickname: "路口的小卖部",
    role: "线索征集参与者",
    quote:
      "我提供的是一个很小的细节，原以为没什么用，后来发现编辑把它和别人的线索拼在了一起，成了完整的一段过程。",
    stars: 4,
  },
];

export const stats = [
  { value: "12000+", label: "累计收到投稿线索" },
  { value: "1-3", label: "工作日完成初筛" },
  { value: "100%", label: "匿名投稿通道" },
  { value: "3", label: "条投稿通道" },
];